import { COMMONCONSTANTS } from "../constants/commonconstants";

export const getCoords= (position) => async (dispatch) => {
    let coords = "GeolocationCoordinates{latitude: 28.6130176, longitude: 77.2308992 }"
    dispatch({
        type: COMMONCONSTANTS.COORDS,
        payload: (position?.coords) ? position.coords : coords
    });
}
